'use client';

import { GetResponseType } from '@/api/types/api';
import { ApiResponseDefinition } from '@/api/types/api-definition';
import dynamic from 'next/dynamic';
import { FC } from 'react';

const SideNavSSR = dynamic(() => import('./SideNav.m'), { ssr: true });

export interface SideNavWrapperProps {
  navData: GetResponseType<ApiResponseDefinition['GET:/api/nav/lists']>;
  isBot: boolean;
}

const SideNavWrapper: FC<SideNavWrapperProps> = ({ navData }) => {
  return <SideNavSSR navData={navData} />;
};

export default SideNavWrapper;
